import { axios_instance } from "./api/axios_instance";
import { decryptRequest } from "./utils/encryptdecryptrequest";

const getDisbursementStatus = async (user) => {
  try {
    const res = await axios_instance({
      url: "/dts/getDisbursementStatus",
      method: "GET",
      headers: {
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    const statuses = decryptRequest(res.data.statuses);

    const disbursement_status = statuses;

    return disbursement_status.map((status) => {
      return { label: status.label, value: status.value };
    });
  } catch (e) {
    return [];
  }
};

const getDisbursementSubStatus = async (user) => {
  try {
    const res = await axios_instance({
      url: "/dts/getDisbursementSubStatus",
      method: "GET",
      headers: {
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    const substatuses = decryptRequest(res.data.substatuses);

    const disbursement_substatus = substatuses.slice(1);

    return disbursement_substatus.map((substatus) => {
      return { label: substatus.label, value: substatus.value };
    });
  } catch (e) {
    return [];
  }
};

const getDisbursementExecutive = async (user) => {
  try {
    const res = await axios_instance({
      url: "/dts/getDisbursementExecutive",
      method: "GET",
      headers: {
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    const executives = decryptRequest(res.data.executives);

    const disbursement_executive = executives;

    return disbursement_executive.map((executive) => {
      return { label: executive.name, value: executive.value };
    });
  } catch (e) {
    return [];
  }
};

const getDisbursementCity = async (user) => {
  try {
    const res = await axios_instance({
      url: "/dts/getDisbursementCity",
      method: "GET",
      headers: {
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    const cities = decryptRequest(res.data.cities);

    return cities;
  } catch (e) {
    return [];
  }
};

const getDisbursementDropdowns = async (user) => {
  try {
    const res = await axios_instance({
      url: "/dts/getDisbursementDropdowns",
      method: "GET",
    });

    const { dropdownList } = decryptRequest(res.data.data);

    const {
      cities,
      executives,
      status,
      subStatus,
      holdStatuses,
      dateTypeArr,
      searchTypeArr,
      payeeTypeList,
    } = dropdownList;

    return {
      cities,
      executives,
      status,
      subStatus,
      holdStatuses,
      dateTypeArr,
      searchTypeArr,
      payeeTypeList,
    };
  } catch (e) {
    return [];
  }
};

const withheldpanel_status = [
  { label: "Open", id: 2 },
  { label: "Issue Identified", id: 4 },
];

const getBanks = async (user) => {
  try {
    const res = await axios_instance({
      url: "/bulkbank/getBanks",
      method: "GET",
    });

    const bulkbankpayment_banks = res.data.banks;

    return bulkbankpayment_banks.map((bank) => {
      return { label: bank.bank_name, id: bank.bank_id };
    });
  } catch (e) {
    return [];
  }
};
export {
  getDisbursementStatus,
  getDisbursementSubStatus,
  getDisbursementExecutive,
  getDisbursementCity,
  getDisbursementDropdowns,
  withheldpanel_status,
  getBanks,
};
